module.exports = __webpack_public_path__ + "static/img/banner3.956e898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner3.png
// module id = qjoL
// module chunks = 1